export const PREFERRED_PAGE_LENGTH_LS_KEY = 'page-length-preference';
export const LAST_VIEWED_PURCHASER_LS_KEY = 'last-viewed-purchaser';
export const PREVIOUS_AUTH_ERROR_KEY = 'previous-auth-error';

export const SUPPORTED_LOCALES = ['en-us', 'da', 'de', 'nb', 'sv'];
export const DEFAULT_LOCALE = 'en-us';

export const ALL_SYNC_USERS_ACROSS_ALL_PAGES_COUNT = 999999;

export const STUDENT_MENU_ACTIONS = {
  NEW_STUDENT: 'NEW-STUDENT',
  IMPORT_STUDENTS: 'IMPORT-STUDENTS',
  REQUEST_TRANSFER: 'REQUEST-TRANSFER',
  EXPORT_STUDENTS: 'EXPORT-STUDENTS',
} as const;

// shared add menu item styles (match HelpMenu padding and focus colours)
export const ADD_MENU_ITEM_CLASS =
  'part-base:p-5 focus-visible:part-base:!bg-grey-50 focus-visible:part-base:!text-black focus-visible:part-base:ring-2 focus-visible:part-base:ring-inset focus-visible:part-base:ring-blue-600';

export const TEACHER_MENU_ACTIONS = {
  INVITE_TEACHERS: 'INVITE-TEACHERS',
  IMPORT_TEACHERS: 'IMPORT-TEACHERS',
  EXPORT_TEACHERS: 'EXPORT-TEACHERS',
} as const;

/**
 * SERVICE ERROR CODES
 */
// Purchaser has no active subscription
export const ERROR_NO_SUBSCRIPTION_PAYWALL = '54020';
// Purchaser subscription does not grant access to Admin Analytics feature
export const ERROR_ANALYTICS_PAYWALL = '54021';
// Purchaser subscription does not have access to Insights
export const ERROR_ANALYTICS_PERMISSION_DENIED = '50017';
// Purchaser subscription has no paid seats
export const ERROR_NO_PRO_SEATS_PAYWALL = '19019';
// Sync session currently running
export const ERROR_SYNC_SESSION_CURRENTLY_RUNNING = '1000';
// Cannot start sync due to duplicate emails
export const ERROR_START_SYNC_DUPLICATE_EMAILS = '1001';
// The session has been invalidated.  Please re-login Showbie.
export const ERROR_SESSION_EXPIRED = '1024';
